import React from 'react';
import styled from 'styled-components';
import type { DeploymentEnvironment } from '../config/deploymentEnvironment';
import { deploymentEnvironment } from '../config/deploymentEnvironment';
import { colors, spacing, typography } from '../styles/theme';

const Banner = styled.div`
  position: relative;
  z-index: 1200;
  width: 100%;
  padding: ${spacing[2]} ${spacing[4]};
  border-bottom: 1px solid #7a4f00;
  background: #fff4d6;
  color: #4a3100;
  font-size: ${typography.fontSizes.sm};
  font-weight: ${typography.fontWeights.semibold};
  line-height: 1.4;
  text-align: center;

  strong {
    color: ${colors.text.primary};
  }
`;

export interface EnvironmentBannerProps {
  environment?: DeploymentEnvironment;
}

export const EnvironmentBanner: React.FC<EnvironmentBannerProps> = ({
  environment = deploymentEnvironment,
}) => {
  if (environment !== 'stage') return null;
  return (
    <Banner role="status" aria-label="Staging environment">
      <strong>Staging environment</strong> · Isolated test data may be reset without notice.
    </Banner>
  );
};

export default EnvironmentBanner;